import { useApp } from "@/context/AppCtx";
import { X, CheckCircle, Info, AlertTriangle } from "lucide-react";
import { useEffect, useState } from "react";

export function GlobalToasts() {
  const { appToasts, removeAppToast } = useApp() as any;

  if (appToasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 left-6 z-[9999] flex flex-col gap-2 pointer-events-none">
      {appToasts.map((toast: any) => (
        <ToastItem key={toast.id} toast={toast} onClose={() => removeAppToast(toast.id)} />
      ))}
    </div>
  );
}

function ToastItem({ toast, onClose }: { toast: any; onClose: () => void }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // trigger animation
    requestAnimationFrame(() => setVisible(true));
  }, []);

  const bg = toast.type === "success" ? "bg-emerald-500/90" 
           : toast.type === "error" ? "bg-rose-500/90" 
           : toast.type === "neutral" ? "bg-black/90"
           : "bg-blue-500/90";
           
  const border = toast.type === "success" ? "border-emerald-400/50" 
               : toast.type === "error" ? "border-rose-400/50" 
               : toast.type === "neutral" ? "border-white/20"
               : "border-blue-400/50";

  return (
    <div 
      className={`pointer-events-auto flex items-start gap-3 p-3 rounded-lg shadow-2xl border backdrop-blur-md text-white transition-all duration-300 ${bg} ${border} ${visible ? "translate-x-0 opacity-100" : "-translate-x-4 opacity-0"}`}
      style={{ minWidth: 280, maxWidth: 360 }}
    >
      <div className="shrink-0 mt-0.5">
        {(toast.type === "success" || toast.type === "neutral") && <CheckCircle className="size-4 text-white" />}
        {toast.type === "error" && <AlertTriangle className="size-4 text-white" />}
        {toast.type === "info" && <Info className="size-4 text-white" />}
      </div>
      <div className="flex-1 text-sm font-medium leading-tight">
        {toast.message}
      </div>
      <button onClick={onClose} className="shrink-0 opacity-60 hover:opacity-100 transition-opacity">
        <X className="size-4" />
      </button>
    </div>
  );
}
